import React, { Component } from 'react';
import { observer } from 'mobx-react';
import CompanyOverview from '../components/CompanyOverview/CompanyOverview';
import ProspectProfile from '../components/CompanyOverview/ProspectProfile';

class TargetProfilePage extends Component {
    render() {
        const { company, step, saveCallback, mode } = this.props;

        return (
            <CompanyOverview step={step}>
                <ProspectProfile company={company} saveCallback={saveCallback} mode={mode} />
            </CompanyOverview>);
    }
}

export default observer(TargetProfilePage);